export class RssContent {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      id: this.fields?.attributes?.id,
      title: this.fields?.attributes?.title,
      feeds: this.fields?.attributes?.relationships
    };
  }
}
